import { all } from 'typed-redux-saga';
import { authSaga } from './auth/auth.saga';

export function* publicSaga(): Generator {
  /* Do nothing */
}

export function* rootSaga(): Generator {
  yield* all([authSaga(), publicSaga()]);
}
